module.exports = __webpack_public_path__ + "assets/img/red-packet.e0d2f7ff.png";